// 封装axios请求模块
import {
  getItem
} from '../utils/storage.js'
import axios from 'axios'
import store from '../store'
import eventBus from '@/utils/eventBus'
import {
  Message
} from 'element-ui'
import router from '@/router'
// 配置基地址
// axios.defaults.baseURL = 'http://toutiao-app.itheima.net/'
// 或者配置不同的信息对象

/**
 * 如果有多个请求都是 403 就需要这个开关 来控制message的展示个数
 * 展示一个之后  关闭阀门
 */
let messageFlag = false
/**
 * props是app.js页面传入的 this.props
 * 用于路由跳转  当403的时候 进行路由跳转
 */
let props = ''

/**
 * 当使用这个js的时候 会监听这个自定义事件
 * 改变props的值
 */
eventBus.$on((propsObj) => {
  props = propsObj
}, 'axiosInterceptorsFun')

const goLoginFun = (res) => {
  if (res.data.code === 405) {
    Message({
      message: res.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
    sessionStorage.clear()
    localStorage.clear()
    router.push('/login')
    return
  }
  if (messageFlag === false) {
    // message.warning("登录已过期，请重新登录！")
    Message({
      // message: '登录已过期，请重新登录' || '服务开小差了，请稍后再试。',
      message: res.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
    messageFlag = true
    setTimeout(() => {
      messageFlag = false
    }, 2000)
  }
}
axios.defaults.timeout = 20000 // 设置默认超时 10s
axios.defaults.withCredentials = true

const axios1 = axios.create({
  // 设置根路径

  baseUrl: 'http://192.168.0.87:8091' // 谢梁
  // 对响应报文体数据进行处理，解决大数据失真问题
  // 执行时机：在axios自动对数据做json.parse之前执行
})
// 1.添加请求拦截器，每次请求都会执行这个拦截器
axios1.interceptors.request.use(function (config) {
  // 取出用户对象
  // config.headers["Content-Type"] = 'application/x-www-form-urlencoded'
  // 判断是否包含用户token,是否存在授权请求头，没有授权就加授权
  if (!config.headers['auth-token'] && getItem('zhrd')) {
    // 向请求报文头追加token
    config.headers['auth-token'] = getItem('zhrd')
  }
  // 返回修改后的配置对象
  return config
})
// 2.添加响应拦截器
axios1.interceptors.response.use(
  // 响应成功进入第1个函数
  // 该函数的参数是响应对象
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // 文件流返回
    if (response.data.type) {
      return response
    }
    const {
      data: {
        code
      }
    } = response
    if (code === 20003 || code === 20004) {
      return response
    }

    if (code === 403) {
      goLoginFun(response)
      return Promise.reject(new Error(response.data
        .msg || 'Error'))
    }

    if (code === 403 || code === 405) {
      goLoginFun(response)
      return response
    }
    if (code !== 200) {
      Message({
        message: response.data
          .msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      return Promise.reject(new Error(response.data
        .msg || 'Error'))
    }
    return response
  },
  // 响应失败进入第2个函数，该函数的参数是错误对象
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // 如果响应码是 401 ，则请求获取新的 token
    // 响应拦截器中的 error 就是那个响应的错误对象
    console.dir(error)
    if (error.response && error.response.status === 401) {
      console.log(error.response, 'error1')
      console.log(error.request, 'error2')
      console.log(error, 'error3')
      // 校验是否有 refresh_token
      const user = store.state.user
      if (!user || !user.refresh_token) {
        this.$router.push('/login')

        // 代码不要往后执行了
        return
      }
      // 如果有refresh_token，则请求获取新的 token
      try {
        const res = await axios1({
          method: 'PUT',
          url: 'http://ttapi.research.itcast.cn/app/v1_0/authorizations',
          headers: {
            Authorization: `Bearer ${user.refresh_token}`
          }
        })
        // 如果获取成功，则把新的 token 更新到容器中
        console.log('刷新 token  成功', res)
        store.commit('setUser', {
          token: res.data.data.token, // 最新获取的可用 token
          refresh_token: user.refresh_token // 还是原来的 refresh_token
        })
        // 把之前失败的用户请求继续发出去
        // config 是一个对象，其中包含本次失败请求相关的那些配置信息，例如 url、method 都有
        // return 把 request 的请求结果继续返回给发请求的具体位置
        return axios1(error.config)
      } catch (err) {
        // 如果获取失败，直接跳转 登录页
        console.log('请求刷线 token 失败', err)
        this.$router.push('/login')
      }
    }
    if (error.response) {
      if (error.response.status === 403 || error.response.status === 405) {
        goLoginFun(error.response)
      }
      return Promise.reject(error.response)
    } else if (error.request) {
      if (error.request.status === 403 || error.request.status === 405) {
        goLoginFun()
      }
      return Promise.reject(error.request)
    } else {
      goLoginFun()
      return Promise.reject(error.message)
    }
  }
)
// 导出axios
export default axios1
